import T from '@/components/Helpers/Translate'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/_ui/Popover'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'
import React from 'react'

const ReferredByPopover = () => {
  const { user } = useGlobalStore()

  return (
    <Popover>
      <PopoverTrigger>
        <span>
          <Image
            alt="Details about referred"
            src="/icons/info.svg"
            width={15}
            height={15}
          />
        </span>
      </PopoverTrigger>
      <PopoverContent className="p-5">
        <span className="text-primary">
          {user.refName} <T>invited</T>
        </span>
        <p className="mt-2 text-xs">
          <T>membership_access</T>
        </p>
      </PopoverContent>
    </Popover>
  )
}

export default ReferredByPopover
